export const sortByAlphabeticalOrder = (a: string, b: string) => {
  return a.toLowerCase().localeCompare(b.toLowerCase())
}
